import { Box, styled } from '@material-ui/core';

const StyledClaimsInquiryDetailsModalBodyContainer = styled(Box)(() => ({
  width: '85vw',
  maxWidth: '1200px',
}));

export { StyledClaimsInquiryDetailsModalBodyContainer };
